import ArchitectureShow from "../components/architecture/Show";

export default [
  { name: 'Architecture', path: '/architecture', component: ArchitectureShow,  }
]
